import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import Logos from './Logos';
import Review from './Review';
import Footer from './Footer';
import { useNavigate } from 'react-router-dom';
import { toWords } from 'number-to-words'; // Import the library

export default function Car() {
  const [productMake, setProductMake] = useState([]);
  const [productModel, setProductModel] = useState([]);
  const [number, setNumber] = useState(''); // To store numeric input
  const [words, setWords] = useState('');  // To store words equivalent of the number
  const newMake = useRef('');
  const newURL = useRef('');
  const navigate = useNavigate();
  const BASE_URL = 'https://node.insuranceadvisors.pk';

  // Handle the change for product make selection
  const handleChange = (event) => {
    newMake.current = event.currentTarget.value;
    newURL.current = BASE_URL + '/api/findprd/' + newMake.current;
   getAllProductModel();
    event.preventDefault();
  };

  // Fetch product models based on the selected product make
  const getAllProductModel = async () => {
    try {
      const response = await axios.get(newURL.current);
      setProductModel(response.data);
    } catch (error) {
      console.error('Error fetching product models:', error);
    }
  };

  // Fetch product makes initially
  const getAllProductMake = () => {
    var url = BASE_URL + '/api/findprd';
    axios.get(url)
      .then((res) => {
        setProductMake(res.data);
      })
      .catch((err) => {
        console.error('Error fetching product makes:', err);
      });
  };

  // Save cart items on form submit
  const saveCartItems = async (event) => {
    event.preventDefault();
    const saveapi = BASE_URL + "/api/saveorder";

    const order = {
      name: event.target.name.value,
      contact: event.target.contact.value,
      email: event.target.email.value,
      productModel: event.target.productModel.value,
      productMake: event.target.productMake.value,
      manufacturingYear: event.target.manufacturingYear.value,
      estimatedValue: event.target.estimatedValue.value
    };

    try {
      const response = await axios.post(saveapi, order);
      console.log('Order saved successfully:', response.data);
      alert('Order Confirmed');
      navigate('/our'); // Navigate to the confirmation page
    } catch (error) {
      console.error('Error saving order:', error);
      alert('Error saving order');
    }
  };

  // Handle changes in the estimated value input
  const handleEstimatedValueChange = (e) => {
    const value = e.target.value;
    setNumber(value); // Update numeric value

    // Convert number to words and set the words state
    if (value) {
      setWords(toWords(parseInt(value))); // Convert number to words
    } else {
      setWords(''); // Clear words if input is empty
    }
  };

  useEffect(() => {
    getAllProductMake();
  }, []);

  return (
    <div>
      <div className='container-fluid trvl mt-0'>
        <h5><marquee>LIMITED TIME OFFER...Offering upto 10% discount on Car Insurance.</marquee></h5>
      </div>

      <div className="container col-12">
        <div className="row">
          <div className="col-12 col-sm-6 mb-3 mb-sm-0 px-0 px-sm-3 mt-0">
            <img src="./assets/img/car.png" alt="Car Image" className="img-fluid" style={{ height: '570px', width: '100%' }} />
          </div>

          <div className="col-12 col-sm-6 mb-3 mb-sm-0" id="d1">
            <h3 className='cl32'>Enter Your Details</h3>
            <form onSubmit={saveCartItems}>
              <select className="form-control form-control-md" name='productMake' required onChange={handleChange}>
                <option value=''>Choose Your Car Make</option>
                {productMake.map((content, index) => (
                  <option key={index} value={content}>{content}</option>
                ))}
              </select>
              <br />
              <select className="form-control form-control-md" name='productModel' required>
                <option value=''>Choose Your Car Model</option>
                {productModel.map((content, index) => (
                  <option key={index} value={content.productModel}>{content.productModel}</option>
                ))}
              </select>
              <br />
              <input
  className="form-control form-control-md"
  name="manufacturingYear"
  placeholder="Manufacturing Year"
  type="number" // Ensure it's a number field
  min="2000" // Minimum year should be 2000
  required
/>

              <br />

              <input
                className="form-control form-control-md"
                name="estimatedValue"
                placeholder="Current Value"
                value={number}
                onChange={handleEstimatedValueChange} // Call function on change
                required
              />
              {words && <p className="white">{words}</p>} {/* Display words below */}
              <br />

              <input className="form-control form-control-md" name='name' placeholder="Enter Your Name" required />
              <br />
              <input className="form-control form-control-md" name='contact' placeholder="Enter Your Contact No" required />
              <br />
              <input className="form-control form-control-md" name='email' type='email' placeholder="Enter Your Email" required />
              <br />
              <div id='d2'>
                <button type="submit" className="btn btn-danger btn-lg">Submit</button>
              </div>
              <br />
            </form>
          </div>
        </div>
      </div>

      <div>
        <Logos />
      </div>
      <br /><br /><br /><br />
      <div>
        <Review />
      </div>
      <br /><br /><br />

      {/* *******************  TYPES OF CAR INSURANCE SECTION STARTS HERE********************* */}
      <div id="ss">
        <div class="insurance-wrapper" id="ss">
          <br /><br />
          <h2>TYPES OF CAR INSURANCE</h2>
          <p class="subheading">We provide an array of services with the guidance of over 25 digital experts who are specialists in their respective fields.</p>

          <div class="cards-wrapper">
            <div class="insurance-card">
              <div class="card-icon"><i class="fas fa-shield-alt"></i></div>
              <h3>Comprehensive Coverage</h3>
              <p>"Get total peace of mind with our Comprehensive Car Coverage. Protecting you from accidents, theft, and nature's surprises, our policy ensures your vehicle is secure inside and out. Drive confidently knowing you're covered for collisions, vandalism, and more. Experience worry-free journeys with our trusted insurance."</p>
            </div>
            <div class="insurance-card">
              <div class="card-icon"><i class="fas fa-car-crash"></i></div>
              <h3>Third Party Insurance</h3>
              <p>"Stay legally protected on the road with our Third Party Car Insurance. Offering essential coverage for damage to others' property and injury to third parties, our policy ensures compliance with regulations while keeping you financially secure. Drive with confidence, knowing you have reliable insurance at your side for peace of mind."</p>
            </div>
            <div class="insurance-card">
              <div class="card-icon"><i class="fas fa-car"></i></div>
              <h3>3T Insurance</h3>
              <p>"Upgrade your coverage to the next level with our 3T Insurance. Combining Third Party, Theft, and Total Loss protection, this comprehensive policy shields you from all angles. Drive worry-free, knowing you're covered for damages to others, theft of your vehicle, and total loss situations. Drive smart, drive protected with 3T Insurance."</p>
            </div>
          </div>
        </div>
      </div>

      {/* ********  Section of 3 steps STARTS HERE ******* */}
      <div className="bg-light">
        <br /> <br />
        <h1 className="achieve1">GET INSURED IN THREE EASY STEPS</h1>
        <br /><br />
        <div class="container">
          <div class="row">
            <div class="col-12 col-sm-4 text-center">
              {/* <img src='https://www.easyinsurance.com.pk/images/supporter/Step2.svg' width='100px' /> */}
              <img src='../assets/img/icon5.png' width='100px' />

              <br /><br />
              <h3><strong>Compare Plans</strong></h3>
              <p>View and Compare Quotes of different Insurance Companies</p>
            </div>

            <div class="col-12 col-sm-4 text-center">
              <img src='../assets/img/icon4.png' width='100px' />
              <br /><br />
              <h3><strong>Choose the Best Plan</strong></h3>
              <p>Select the best plan based on your needs and budget</p>
            </div>

            <div class="col-12 col-sm-4 text-center">
              <img src='../assets/img/icon7.png' width='100px' />
              <br /><br />
              <h3><strong>Get Insured</strong></h3>
              <p>Submit Documents and Pay online to get your Insurance</p>
            </div>
          </div>
        </div>
        <br /><br />
      </div>

      <div>
        <Footer />
      </div>
    </div>
  );
}
